import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveBranchFailure, saveBranchSuccess, updateBranchFailure, updateBranchSuccess } from './actions';

export function* saveBranch({ payload }) {
  try {
    const response = yield call(api.post, 'api/branch', payload.data, { withCredentials: true });

    yield put(saveBranchSuccess());

    toast.success('Dependência criada com sucesso!')

    const id = response.headers.location;

    history.push(`/specifications/branches`);
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveBranchFailure());
  }
}

export function* updateBranch({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/branch/${id}`, payload.data, { withCredentials: true });

    yield put(updateBranchSuccess());

    toast.success('Dependência atualizada com sucesso!')

    history.push('/specifications/branches');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateBranchFailure());
  }
}

export default all([
  takeLatest('@branch/SAVE_REQUEST', saveBranch),
  takeLatest('@branch/UPDATE_REQUEST', updateBranch)
]);